import styled, { css } from "styled-components/macro";

import { TinyText } from "shared/styles";
import { IStatus } from "shared/types";
import { getStatus } from "shared/styles/defaults";
import { space } from "shared/styles/constants";

export interface StyledBadgeProps {
  status?: IStatus;
}

export const StyledBadge = styled(TinyText)<StyledBadgeProps>`
  padding: 2px ${space.xs};
  border-radius: 100px;

  ${({ status }) =>
    status &&
    css`
      background-color: ${getStatus(status).bgColor};
      color: ${getStatus(status).buttonTextColor};
    `};
`;
